import { render, staticRenderFns } from "./ModuleContainer.vue?vue&type=template&id=1e7f8798"
import script from "./ModuleContainer.vue?vue&type=script&lang=js"
export * from "./ModuleContainer.vue?vue&type=script&lang=js"
import style0 from "./ModuleContainer.vue?vue&type=style&index=0&id=1e7f8798&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports